import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ChatIcon from "@mui/icons-material/Chat";
import MessageIcon from "@mui/icons-material/Message"
import SettingsIcon from "@mui/icons-material/Settings"
import StorageIcon from "@mui/icons-material/Storage"
import ArticleIcon from "@mui/icons-material/Article";

export const mainListItems = (
  <React.Fragment>
    <ListItemButton href="/console">
      <ListItemIcon>
        <DashboardIcon />
      </ListItemIcon>
      <ListItemText primary="Dashboard" />
    </ListItemButton>
    <ListItemButton href="/console/sessions">
      <ListItemIcon>
        <MessageIcon />
      </ListItemIcon>
      <ListItemText primary="Sessions" />
    </ListItemButton>
    <ListItemButton href="/console/structured">
      <ListItemIcon>
        <StorageIcon />
      </ListItemIcon>
      <ListItemText primary="Structured Data" />
    </ListItemButton>
    <ListItemButton href="/console/unstructured">
      <ListItemIcon>
        <ArticleIcon />
      </ListItemIcon>
      <ListItemText primary="Unstructured Data" />
    </ListItemButton>
    <ListItemButton href="/console/settings">
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText primary="Settings" />
    </ListItemButton>
  </React.Fragment>
);

export const secondaryListItems = (
  <React.Fragment>
    <ListSubheader component="div" inset>
      Tools
    </ListSubheader>
    <ListItemButton href="/console/chat">
      <ListItemIcon>
        <ChatIcon />
      </ListItemIcon>
      <ListItemText primary="Chat" />
    </ListItemButton>
    <ListItemButton href="/chat-v1">
      <ListItemIcon>
        <MessageIcon />
      </ListItemIcon>
      <ListItemText primary="Chat (Legacy)" />
    </ListItemButton>
  </React.Fragment>
);